import {PropsWithChildren} from "react";
import {Link, useLocation} from "react-router-dom";
import {css, cx} from "@panda/css";

import {isPathPrefixActive} from "../utils/is_path_prefix_active";

interface IProps extends PropsWithChildren {
    activeClassName?: string;
    className?: string;
    dataTestId?: string;
    onNavigate?: () => void;
    to: string;
}

export const NavigationLinkItem = (props: IProps) => {
    const {activeClassName, children, className, dataTestId, onNavigate, to} = props;
    const location = useLocation();
    const isActive = isPathPrefixActive(location.pathname, to);

    const handleClick = () => {
        onNavigate?.();
        window.scrollTo({top: 0});
    };

    return (
        <Link
            aria-current={isActive ? "page" : undefined}
            className={cx(className, isActive && activeClassName)}
            data-testid={dataTestId}
            onClick={handleClick}
            to={to}
        >
            {children}
        </Link>
    );
};

export const navigationLinkItemResetStyle = css({
    color: "inherit",
    textDecoration: "none",
    _focusVisible: {
        outline: "2px solid var(--colors-info)",
        outlineOffset: "-2px",
        borderRadius: 1
    }
});
import {PropsWithChildren} from "react";
import {Link, useLocation} from "react-router-dom";
import {css, cx} from "@panda/css";

import {isPathPrefixActive} from "../utils/is_path_prefix_active";

interface IProps extends PropsWithChildren {
    activeClassName?: string;
    className?: string;
    dataTestId?: string;
    onNavigate?: () => void;
    to: string;
}

export const NavigationLinkItem = (props: IProps) => {
    const {activeClassName, children, className, dataTestId, onNavigate, to} = props;
    const location = useLocation();
    const isActive = isPathPrefixActive(location.pathname, to);

    const handleClick = () => {
        onNavigate?.();
        window.scrollTo({top: 0});
    };

    return (
        <Link
            aria-current={isActive ? "page" : undefined}
            className={cx(className, isActive && activeClassName)}
            data-testid={dataTestId}
            onClick={handleClick}
            to={to}
        >
            {children}
        </Link>
    );
};

export const navigationLinkItemResetStyle = css({
    color: "inherit",
    textDecoration: "none",
    _focusVisible: {
        outline: "2px solid var(--colors-info)",
        outlineOffset: "-2px",
        borderRadius: 1
    }
});
